/* ===========================================================================
   new-product-recs.js — companion for sections/new-product-recs.liquid
   - source "related": fetch the section via the Product Recommendations API,
     swap it in (drop the section if there are none)
   - outer Swiper slider (full bleed, swipe / drag — no arrows)
   - per card (snippets/card-newproduct.liquid): image carousel + hover cross-fade,
     colour swatch -> image swap, hover quick size add-to-cart
   Self-contained — does NOT load new-collection.js. Helpers ported from it.
   =========================================================================== */
(function () {
  'use strict';
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------------- cart ---------------- */
  function addToCart(variantId) {
    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) {}
    }
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { throw res.data; }
        var done = false;
        if (cartDrawer && res.data.sections && typeof cartDrawer.renderContents === 'function') {
          try { cartDrawer.renderContents(res.data); done = true; } catch (e) {}
        }
        if (!done) { setTimeout(function () { window.location = shopRoot() + 'cart'; }, 600); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'new-product-recs', productVariantId: variantId }); } catch (e) {}
        }
        return res.data;
      });
  }

  function toast(msg) {
    var t = document.getElementById('npr-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'npr-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:22px;transform:translateX(-50%);background:#111;color:#fff;padding:11px 18px;font:13px/1.35 sans-serif;z-index:99999;max-width:90vw;text-align:center;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.display = 'none'; }, 3500);
  }

  /* ---------------- card variant data ---------------- */
  function parseData(card) {
    var el = card.querySelector('[data-ncg-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function sizeValues(card) {
    var d = card._npr.data, si = card._npr.sizeIdx;
    if (si < 0) return [];
    var seen = {}, out = [];
    for (var i = 0; i < d.variants.length; i++) {
      var s = d.variants[i].opts[si];
      if (!(s in seen)) { seen[s] = 1; out.push(s); }
    }
    return out;
  }
  function variantFor(card, color, size) {
    var d = card._npr.data, ci = card._npr.colorIdx, si = card._npr.sizeIdx;
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (si > -1 && size != null && v.opts[si] !== size) continue;
      if (ci > -1 && color != null && v.opts[ci] !== color) continue;
      return v;
    }
    return null;
  }

  /* ---------------- per-card ---------------- */
  function initCard(card) {
    if (card.dataset.nprCardReady === '1') return;
    card.dataset.nprCardReady = '1';
    card._npr = { data: null, colorIdx: -1, sizeIdx: -1, color: null };

    var data = parseData(card);
    if (data) {
      card._npr.data = data;
      card._npr.colorIdx = data.colorName ? data.optionNames.indexOf(data.colorName) : -1;
      card._npr.sizeIdx = data.sizeName ? data.optionNames.indexOf(data.sizeName) : -1;
      var cur = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === data.current) { cur = data.variants[i]; break; }
      }
      card._npr.color = (cur && card._npr.colorIdx > -1) ? cur.opts[card._npr.colorIdx] : null;
    }

    bindSlider(card);
    if (!data) return;
    bindSwatches(card);
    buildSizes(card);
    bindSizeClicks(card);
  }

  function bindSlider(card) {
    var slider = card.querySelector('[data-ncg-slider]');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.ncg-card__slide'));
    var prev = card.querySelector('[data-ncg-prev]');
    var next = card.querySelector('[data-ncg-next]');
    if (slides.length < 2) { if (prev) prev.remove(); if (next) next.remove(); return; }

    var inited = false, api = {};
    function ensure() {
      if (inited) return;
      inited = true;
      if (typeof window.Swiper === 'function') {
        var sw = new window.Swiper(slider, {
          slidesPerView: 1, loop: true, speed: 450, followFinger: true, nested: true,
          resistanceRatio: 0.6, longSwipesRatio: 0.25, threshold: 4
        });
        api.next = function () { sw.slideNext(); };
        api.prev = function () { sw.slidePrev(); };
        api.index = function () { return sw.realIndex; };
        api.hoverShow = function () { sw.slideToLoop(1, 0); };
        api.reset = function () { sw.slideToLoop(0, 0); };
      } else {
        var idx = 0;
        slides.forEach(function (s, k) { s.style.position = 'absolute'; s.style.inset = '0'; s.style.display = k ? 'none' : 'block'; });
        var show = function (i) { idx = (i + slides.length) % slides.length; slides.forEach(function (s, k) { s.style.display = k === idx ? 'block' : 'none'; }); };
        api.next = function () { show(idx + 1); };
        api.prev = function () { show(idx - 1); };
        api.index = function () { return idx; };
        api.hoverShow = function () { show(1); };
        api.reset = function () { show(0); };
      }
    }
    function arm(btn, fn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ensure(); fn(); });
    }
    arm(prev, function () { api.prev(); });
    arm(next, function () { api.next(); });

    // Build Swiper ahead of time, once the card is about to scroll into
    // view, instead of waiting for the first touch. Building it lazily
    // inside the same touchstart that must also register as "open the
    // product" caused the DOM (loop-mode slide clones) to shift under the
    // finger mid-tap, so the tap-to-click handoff silently failed on iOS
    // Safari (Android's Chrome tolerates the shift and still clicks through).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { ensure(); io.disconnect(); }
      }, { rootMargin: '200px' });
      io.observe(card);
    }

    if (window.matchMedia('(hover: hover)').matches) {
      card.addEventListener('pointerenter', function () { ensure(); if (api.index && api.index() === 0) api.hoverShow(); });
      card.addEventListener('pointerleave', function () { if (api.reset) api.reset(); });
    }
    var hideT;
    function showArrows() { clearTimeout(hideT); card.classList.add('is-touch'); }
    function hideLater() { clearTimeout(hideT); hideT = setTimeout(function () { card.classList.remove('is-touch'); }, 2500); }
    card.addEventListener('touchstart', function () { ensure(); showArrows(); }, { passive: true });
    card.addEventListener('touchend', hideLater, { passive: true });
    card.addEventListener('touchcancel', hideLater, { passive: true });
  }

  function bindSwatches(card) {
    var box = card.querySelector('[data-ncg-swatches]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-ncg-swatch]');
      if (!sw) return;
      e.preventDefault(); e.stopPropagation();
      var color = sw.getAttribute('data-color');
      card._npr.color = color;
      box.querySelectorAll('[data-ncg-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
      var v = variantFor(card, color, null);
      var img = card.querySelector('.ncg-card__img--main');
      if (v && v.img && img) { img.setAttribute('src', v.img); img.removeAttribute('srcset'); }
      if (v && card._npr.data) {
        var base = card._npr.data.url;
        card.querySelectorAll('a[href]').forEach(function (a) {
          var href = a.getAttribute('href') || '';
          if (href.indexOf(base) === 0) a.setAttribute('href', base + '?variant=' + v.id);
        });
      }
      buildSizes(card);
    });
  }

  function buildSizes(card) {
    var box = card.querySelector('[data-ncg-sizes]');
    if (!box) return;
    var sizes = sizeValues(card);
    if (!sizes.length) { box.hidden = true; return; }
    var color = card._npr.color;
    box.innerHTML = '';
    sizes.forEach(function (sz) {
      var v = variantFor(card, color, sz);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ncg-card__size' + ((!v || !v.available) ? ' is-sold-out' : '');
      b.textContent = sz;
      b.setAttribute('data-size', sz);
      if (v) b.setAttribute('data-variant-id', v.id);
      box.appendChild(b);
    });
    box.hidden = false;
  }

  function bindSizeClicks(card) {
    var box = card.querySelector('[data-ncg-sizes]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.ncg-card__size');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      if (btn.classList.contains('is-sold-out') || !vid) {
        window.location = (card._npr.data && card._npr.data.url) || (card.querySelector('a[href]') || {}).href || '/';
        return;
      }
      btn.disabled = true;
      addToCart(Number(vid))
        .then(function () { toast('Added to cart'); })
        .catch(function () { toast('Could not add — open the product'); })
        .then(function () { btn.disabled = false; });
    });
  }

  /* ---------------- section ---------------- */
  function initSection(root) {
    if (!root || root.dataset.nprReady === '1') return;

    var fetchUrl = root.getAttribute('data-npr-fetch');
    if (fetchUrl && !root.querySelector('[data-npr-slider]')) {
      root.dataset.nprReady = '1';
      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(root.id) || doc.querySelector('[data-npr-root]');
          if (fresh && fresh.querySelector('[data-npr-slider]')) {
            root.innerHTML = fresh.innerHTML;
            root.classList.remove('npr--empty');
            build(root);
          } else {
            root.remove();
          }
        })
        .catch(function () { root.remove(); });
      return;
    }
    root.dataset.nprReady = '1';
    build(root);
  }

  function build(root) {
    var sliderEl = root.querySelector('[data-npr-slider]');
    if (!sliderEl) return;

    /* gender match — the recommendations endpoint renders without the current
       product, so the Liquid filter can't see its tags. Match here instead:
       keep only cards sharing a tag with the product being viewed. If nothing
       would remain, leave the row untouched. */
    var cur = (root.getAttribute('data-cur-gender') || '').split(',').filter(Boolean);
    if (cur.length) {
      var cells = Array.prototype.slice.call(root.querySelectorAll('.npr__cell'));
      var keep = cells.filter(function (c) {
        var tags = c.getAttribute('data-tags') || '';
        return cur.some(function (g) { return tags.indexOf(',' + g + ',') > -1; });
      });
      if (keep.length) {
        cells.forEach(function (c) { if (keep.indexOf(c) === -1) c.remove(); });
      }
    }

    var gap = parseInt(root.getAttribute('data-card-gap'), 10);
    if (isNaN(gap)) gap = 2;

    if (window.Swiper) {
      // slidesPerView:'auto' → Swiper honours the CSS card width, which is sized
      // to leave a peek of the next card (the "there's more, swipe" cue).
      var sw = new window.Swiper(sliderEl, {
        wrapperClass: 'npr__list',
        slideClass: 'npr__cell',
        slidesPerView: 'auto',
        spaceBetween: gap
      });
      // Swiper often measures before images load — re-check once settled
      setTimeout(function () { sw.update(); }, 350);
      window.addEventListener('load', function () { sw.update(); });
    } else {
      var wrap = root.querySelector('[data-npr-list]');
      if (wrap) { wrap.style.overflowX = 'auto'; wrap.style.webkitOverflowScrolling = 'touch'; }
    }

    each(root.querySelectorAll('[data-ncg-card]'), initCard);
  }

  function boot(scope) {
    each((scope || document).querySelectorAll('[data-npr-root]'), initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
